import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import ProjectValidationSchema from 'src/validation/ProjectValidationSchema';
import { ValidationMessages } from 'src/components/common/ValidationMessage';
import { deleteProject } from "src/store/project";
import { getClients } from "src/store/client";
import { getProjects } from "src/store/project";
import { getUsers } from "src/store/user";
import { getMcode } from "src/store/mcode";
import { getSingleProjects } from "src/store/project";
import { fetchProjectStaffById } from "src/store/projectstaff";
import { resetSingleProject, resetStateIdele } from 'src/store/project';
import { formatDate } from "src/utils/Helper";
import { CopyContext } from 'src/context/CopyContext';
import { format } from "date-fns";

const ProjectForm = (props) => {
  const {
    id = 0
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [validationMessages, setValidationMessages] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [addedItems, setAddedItems] = useState([]);

  const user = useSelector((state) => state.user.data);
  const authCd = useSelector((state) => state.mcode.data.projectcategory);
  const authRole = useSelector((state) => state.mcode.data.role);
  const clientName = useSelector((state) => state.client.data);
  const projectStatus = useSelector((state) => state.project.status);
  const projectSingleData = useSelector((state) => state.project.singleData);
  const projectStaff = useSelector((state) => state.projectstaff.data);
  const { copyFlg } = useContext(CopyContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(ProjectValidationSchema),
    mode: 'onSubmit',
    defaultValues: {
      id: id,
    }
  });

const onSubmit = (data) => {
  if (!addedItems || addedItems.length === 0) {
    alert("No staff added yet. Please add staff before proceeding.");
    return;
  }

  const formattedStartDate = format(data.start_date, "yyyy-MM-dd");
  const formattedEndDate = format(data.end_date, "yyyy-MM-dd");
  const formattedOrderDate = formatDate(data.order_date);
  const formattedBillingDate = formatDate(data.billing_date);

  const formatedData = {
    ...data,
    Project_staff_data: addedItems,
    start_date: formattedStartDate,
    end_date: formattedEndDate,
    order_date: formattedOrderDate,
    billing_date: formattedBillingDate,
  };

  navigate("/projectConfirm", { state: { formData: formatedData } });
};


  const clickBackBtn = () => {
    navigate("/projectList");
  };

  const clickDeleteBtn = async () => {
    const deleteConfirmed = window.confirm("Are you sure you want to delete?");
    if (!deleteConfirmed) {
      return; // Exit if the user cancels the confirmation
    }
    dispatch(deleteProject(id))
      .then((response) => {
        if (response.payload?.errors) {
          const messagesArray = Object.values(response.payload.errors).map((error) => error);
          setValidationMessages(messagesArray);
        }
        else if (deleteProject.fulfilled.match(response)) {
          alert(response.payload?.message);
          navigate("/projectList");
        }
        else if (deleteProject.rejected.match(response)) {
          setValidationMessages(response.error?.message);
        }
        else if (response?.error) {
          setValidationMessages(response.error.message);
        }
      })
      .catch((error) => {
        setValidationMessages([error.message]);
      });
  };

  useEffect(() => {
    if (isDataLoaded) {
      if (location.state?.formData) {
        reset(location.state.formData);
        setAddedItems(location.state.formData.Project_staff_data);

      }

      else if (projectSingleData && Object.keys(projectSingleData).length !== 0) {
        const formattedData = {
          ...projectSingleData,
          start_date: projectSingleData.start_date ? format(new Date(projectSingleData.start_date), "yyyy-MM-dd") : "",
          end_date: projectSingleData.end_date ? format(new Date(projectSingleData.end_date), "yyyy-MM-dd") : "",
          order_date: projectSingleData.order_date ? format(new Date(projectSingleData.order_date), "yyyy-MM-dd") : "",
          billing_date: projectSingleData.billing_date ? format(new Date(projectSingleData.billing_date), "yyyy-MM-dd") : "",
          billing_plans_date: projectSingleData.billing_plans_date ? format(new Date(projectSingleData.billing_plans_date), "yyyy-MM-dd") : ""
        };

        if (projectStaff && projectStaff.data && projectStaff.data.length > 0) {
          
          const firstStaff = projectStaff.data[0];
          setValue('project_staff_id', firstStaff.t_user_id.toString());
          setValue('staff_role_cd', firstStaff.role_cd.toString());
          setValue('unit_price_cd', firstStaff.unit_price.toString());
          
          const formattedStaffData = projectStaff.data.map(staff => {
            const staffUser = user.find(u => u.id === staff.t_user_id);
            const staffRole = authRole.find(role => role.cd === String(staff.role_cd));
            
            return {
              projectStaffId: staff.t_user_id,
              projectStaffName: staffUser ? staffUser.name : '',
              staffRoleCd: staff.role_cd,
              staffRoleName: staffRole ? staffRole.code_value1 : '',
              unit_price_cd: staff.unit_price,
            };
          });
          setAddedItems(formattedStaffData);
        }
        reset(formattedData);
      }

    }
  }, [isDataLoaded, location.state, projectSingleData, projectStaff, user, authRole, reset]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          dispatch(getClients({ name: 'name' })),
          dispatch(getProjects()),
          dispatch(getUsers()),
          dispatch(getMcode({ section_cd: 'projectcategory,role ' })),
          dispatch(getSingleProjects(id)),
          dispatch(fetchProjectStaffById(id))
        ]);
        setIsDataLoaded(true);
      } catch (error) {
        console.error('Error loading data:', error);
      }
    };

    fetchData();

    return () => {
      dispatch(resetSingleProject());
      setIsDataLoaded(false);
    };
  }, [dispatch, id]);


  useEffect(() => {
    const messagesArray = Object.values(errors).map((error) => error.message);
    setValidationMessages(messagesArray);
  }, [errors]);

  useEffect(() => {
    if (validationMessages.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [validationMessages]);

  useEffect(() => {
    if (projectStatus === 'succeeded') {
      dispatch(resetStateIdele());
    }
  }, [projectStatus]);

  const addProjectStaff = () => {
    const projectStaffId = parseInt(getValues("project_staff_id"), 10);
    const staffRoleCd = parseInt(getValues("staff_role_cd"), 10);
    const unitPriceCd = parseFloat(getValues("unit_price_cd"));

    if (!projectStaffId || !staffRoleCd || isNaN(unitPriceCd)) {
      alert("Please select all fields before adding.");
      return;
    }

    const existingItem = addedItems.find(item => item.projectStaffId === projectStaffId);

    if (existingItem) {
      if (existingItem.staffRoleCd === staffRoleCd) {
        alert("This staff and role combination has already been added.");
      } else {
        alert("This staff has already been added.");
      }
      return;
    }

    const selectedUser = user.find(u => parseInt(u.id, 10) === projectStaffId);
    const selectedRole = authRole.find(r => parseInt(r.cd, 10) === staffRoleCd);

    setAddedItems(prev => [
      ...prev,
      {
        projectStaffId: projectStaffId,
        projectStaffName: selectedUser?.name || "(Unknown)",
        staffRoleCd: staffRoleCd,
        staffRoleName: selectedRole?.code_value1 || "(Unknown Role)",
        unitPrice: unitPriceCd,
      }
    ]);
  };

  const removeItem = (indexToRemove) => {
    setAddedItems(prev => prev.filter((_, idx) => idx !== indexToRemove));
  };

  return (
    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
      <input type="hidden" {...register("id")} />
      {validationMessages && validationMessages.length > 0 && (
        <div style={{ background: "#ffe4e2" }}>
          <ValidationMessages
            messages={validationMessages}
            onClose={() => setValidationMessages([])}
          />
        </div>
      )}

      {/* Client */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Client *
        </label>
        <div className="col-sm-9">
          <select name="client_id" className="form-control" {...register("t_client_id")}>
            <option value="">-----</option>
            {clientName && clientName.map((client) => (
              <option
                key={client.id}
                value={(client.id)}
              >
                {client.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Client Project Id *
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            maxLength={128}
            {...register("client_project_id")}
          />
        </div>
      </div>

      {/* Project Name */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project Name *
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            maxLength={128}
            {...register("name")}
          />
        </div>
      </div>

      {/* Project name (abbreviation) */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project name (abbreviation) *
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            maxLength={128}
            {...register("name_abbreviation")}
          />
        </div>
      </div>

      {/* Project Details */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project Details
        </label>
        <div className="col-sm-9">
          <textarea
            type="textarea"
            rows="3"
            className="form-control"
            {...register("detail")}
          />
        </div>
      </div>

      {/* Project Category */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project Category *
        </label>
        <div className="col-sm-9">
          <select name="category_cd" className="form-control"
            {...register("category_cd")}>
            <option value="">-----</option>
            {authCd && authCd.map((auth_cd) => (
              <option
                key={auth_cd.cd}
                value={auth_cd.cd}
              >{auth_cd.code_value1}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Order Date */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Order Date
        </label>
        <div className="col-sm-9 form-inline">
          <input
            type="date"
            className="form-control pj-datetimepicker"
            {...register("order_date")}
          />
        </div>
      </div>

      {/* Billing date (scheduled billing date) */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Billing date (scheduled billing date)</label>
        <div className="col-sm-9 form-inline">
          <input
            type="date"
            className="form-control pj-datetimepicker"
            {...register("billing_date")}
          />
          {!copyFlg ? (
            <>
              （&nbsp;
              <input
                type="date"
                className="form-control pj-datetimepicker"
                {...register("billing_plans_date")}
              />
              &nbsp;）
            </>
          ) : null}
        </div>
      </div>

      {/* Order amount (excluding tax) */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Order amount (excluding tax) *</label>
        <div className="col-sm-9">
          <input
            type="number"
            className="form-control"
            {...register("order_price")}
          />
        </div>
      </div>

      {/* Consumption tax rate */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Consumption tax rate *
        </label>
        <div className="col-sm-9">
          <input
            type="number"
            className="form-control"
            {...register("order_price_tax_rate")}
          />
        </div>
      </div>

      {/* Project duration */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project duration *
        </label>
        <div className="col-sm-9 form-inline">
          <input
            type="date"
            className="form-control pj-datetimepicker"
            {...register("start_date")}
          />
          &nbsp;～&nbsp;
          <input
            type="date"
            className="form-control pj-datetimepicker"
            {...register("end_date")}
          />
        </div>
      </div>

      {/* Project Leader */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project Leader *
        </label>
        <div className="col-sm-9">
          <select name="manager_id" className="form-control" {...register("manager_id")}>
            <option value="">-----</option>
            {user && user.map((userItem) => (
              <option key={userItem.id} value={userItem.id}>
                {userItem.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Project Sub-Leader */}
      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project Sub-Leader *
        </label>
        <div className="col-sm-9">
          <select name="sub_manager_id" className="form-control" {...register("sub_manager_id")}>
            <option value="">-----</option>
            {user && user.map((userItem) => (
              <option key={userItem.id} value={userItem.id}>
                {userItem.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-group">
        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
          Project Staff *
        </label>

        <div className="col-sm-9">
          <div className="form-inline" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
            {/* Project Staff Select */}
            <select
              name="project_staff_id"
              className="form-control"
              {...register("project_staff_id")}
              style={{ minWidth: "150px" }}
            >
              <option value="">-----</option>
              {user?.map((userItem) => (
                <option key={userItem.id} value={userItem.id}>
                  {userItem.name}
                </option>
              ))}
            </select>

            {/* Role Select */}
            <label style={{ marginBottom: 0 }}>Role *</label>
            <select
              name="staff_role_cd"
              className="form-control"
              {...register("staff_role_cd")}
              style={{ minWidth: "150px" }}
              onChange={(e) => {
                const selectedValue = e.target.value;
                const selectedRole = authRole.find(role => role.cd === selectedValue);
                if (selectedRole) {
                  setValue("unit_price_cd", selectedRole.code_value2 || "");
                }
              }}
            >
              <option value="">-----</option>
              {authRole?.map((auth_role) => (
                <option key={auth_role.cd} value={auth_role.cd}>
                  {auth_role.code_value1}
                </option>
              ))}
            </select>

            {/* Unit Price Input */}
            <label style={{ marginBottom: 0 }}>Unit Price *</label>
            <input
              type="text"
              name="unit_price_cd"
              className="form-control"
              style={{ width: "100px" }}
              {...register("unit_price_cd")}
            />

            {/* Add Button */}
            <button type="button" className="btn btn-default" onClick={addProjectStaff}>
              <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
            </button>
          </div>

          {/* Display Added Items */}
          {addedItems.length > 0 && (
            <div style={{ marginTop: "20px", border: "1px solid #ccc", padding: "12px", borderRadius: "4px" }}>
              {addedItems.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    marginBottom: "8px",
                    display: "flex",
                    gap: "20px",
                    alignItems: "center"
                  }}
                >                    <span style={{ fontSize: "small", display: "inline-block" }}>
                    <strong>【{item.staffRoleName}】</strong> {item.projectStaffName}, Unit Price: {item.unit_price_cd}
                    <span
                      className="glyphicon glyphicon-remove"
                      aria-hidden="true"
                      onClick={() => removeItem(idx)}
                      style={{
                        color: "#337ab7",
                        cursor: "pointer",
                        marginLeft: "8px"
                      }}
                    ></span>
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Buttons */}
      <div className="form-group text-center" style={{ marginTop: 60 }}>
        <button type="button" className="btn btn-default btn-lg" style={{ margin: "0 10px" }} onClick={clickBackBtn}>
          Back
        </button>
        <button type="submit" className="btn btn-success btn-lg jq-confirm_data" style={{ margin: "0 10px" }} >
          Confirm
        </button>
      </div>
      {id ?
        <div className="form-group text-center">
          <button type="button" className="btn btn-default btn-lg" style={{ margin: "0 10px" }} onClick={clickDeleteBtn}>
            Delete
          </button>
        </div>
        : null
      }
    </form>
  );
};

export default ProjectForm;
